export default __webpack_public_path__ + "static/media/5-2.51ffb6b7.png";